import React from 'react'
import { Form, Button, PageHeader, Breadcrumb, Divider, Row, Col } from 'antd';
import { Content } from 'antd/lib/layout/layout';
import { Link } from 'react-router-dom';
import { TabletFilled } from '@ant-design/icons';
import history from '../../../history';
import CommonForm from '../../../component/form/form';
import { connect } from 'react-redux';
import {createNewRole} from '../../../actions/role'

const layout = {
    labelCol: { span: 4 },
    wrapperCol: { span: 16 },
  };
  const tailLayout = {
    wrapperCol: { offset: 4, span: 16 },
  };

  
  class CreateRole extends CommonForm {
    state = { 
      data: {
        username: '',
        password: '',
      }
     }
    onFinish = (values) => {
        this.props.createNewRole(values)
      };
   
      onFinishFailed = (errorInfo) => {
        // console.log('Failed:', errorInfo);
      };
      render() { 
    return (
        <Content>
            <Breadcrumb style={{padding:"10px 0px"}}>
              <Breadcrumb.Item><Link to="/dashboard">Home</Link></Breadcrumb.Item>
              <Breadcrumb.Item>Create Role</Breadcrumb.Item>
            </Breadcrumb>
            <PageHeader
              ghost={false}
              onBack={() => window.history.back()}
              title="Create Role"
              subTitle="Role Management"
              extra={[
                <Button key="1"  type="primary" icon={<TabletFilled />} onClick = { () => history.push('/roles')}>Role List
                </Button>,
              ]}
            >
            </PageHeader>
            <br />
            <Form
              {...layout}
              name="basic"
              initialValues={{ remember: true }}
              onFinish={this.onFinish}
              onFinishFailed={this.onFinishFailed}
            >
              {this.renderInput('role', 'Role Name', [
                  { required: true, message: 'Role name is required' },
                ])
              }
               <Divider orientation="center">Assign role's access</Divider>
              <Row>
                <Col flex="1 1 200px">
                  {this.renderCheckbox('user_management', 'User Management',  [
                      { required: false },
                    ])
                  }
                  {this.renderCheckbox('client_management', 'Client Management',   [
                      { required: false },
                    ])
                  }
                  {this.renderCheckbox('app_management', 'App Management', [
                      { required: false },
                    ])
                  }
                   {this.renderCheckbox('code_management', 'Code Management', [
                      { required: false },
                    ])
                  }
                   {this.renderCheckbox('report_management', 'Report Management', [
                      { required: false },
                    ])
                  }
                </Col>
                <Col flex="1 1 200px">
                  {this.renderCheckbox('finance_management', 'Finance Management',  [
                      { required: false },
                    ])
                  }
                  
                  {this.renderCheckbox('product_management', 'Product Management', [
                      { required: false },
                    ])
                  }
                  {this.renderCheckbox('support_management', 'Support Management', [
                      { required: false },
                    ])
                  }
                  {this.renderCheckbox('setting_management', 'Setting Management', [
                      { required: false },
                    ])
                  }
                 
                </Col>
              </Row>
              
              <Form.Item {...tailLayout}> 
                <Button type="primary" htmlType="submit">
                  Submit
                </Button>
              </Form.Item>
            
            </Form>
    
    </Content>
    )
  }
}

 
export default connect(null,{createNewRole})(CreateRole);